import { Layout, Spacing } from "@p0security/ui";
import { Outlet, Route } from "react-router-dom";

import { Page } from "../components/App/Page";
import { ReactComponent as Privacy } from "./privacy.md";
import { ReactComponent as Tos } from "./tos.md";

export const PolicyRoutes = (
  <Route
    element={
      <Layout>
        <Spacing asChild m="24px 16px">
          <Layout.Content
            className="site-layout-background"
            /* eslint-disable-line react/forbid-component-props */ style={{
              background: "#fff",
              padding: 24,
              minHeight: 280,
              overflow: "auto",
            }}
          >
            <Outlet />
          </Layout.Content>
        </Spacing>
      </Layout>
    }
  >
    <Route
      path="privacy"
      element={
        <Page title="Privacy Policy">
          <Privacy />
        </Page>
      }
    />
    <Route
      path="tos"
      element={
        <Page title="Terms of Service">
          <Tos />
        </Page>
      }
    />
  </Route>
);
